import { DrawableMediaInstance } from '../../media/MediaData';

export class StimulusContent {
  stimulus: DrawableMediaInstance;

  constructor(stimulus: DrawableMediaInstance) {
    this.stimulus = stimulus;
  }
}
